import React, { useEffect } from 'react'
import { useState } from 'react'
import { CRow, CCol, CWidgetStatsC } from '@coreui/react-pro'

import CIcon from '@coreui/icons-react'
import {
  cibCcStripe,
  cilAppsSettings,
  cilMinus,
  cilPeople,
  cilUserFollow,
  cilUserPlus,
  cilUserX,
  cilWallet,
} from '@coreui/icons'
import UserService from 'src/service/UserService'

const GamePayment = () => {
  const [totalUser, setTotalUser] = useState()
  const [stripePayment, setStripePayment] = useState()
  const [manualPayment, setManualPayment] = useState()
  const [entryPriceSymbol, setEntryPriceSymbol] = useState()
  useEffect(() => {
    getGamePayment()
  }, [])
  const getGamePayment = () => {
    UserService.getGamePayment().then((result) => {
      setStripePayment(result.stripPayment)
      setManualPayment(result.manualPayments)
      setTotalUser(result.userCount)
      setEntryPriceSymbol(result.entry_price_symbol)
    })
  }
  const calculateTotalCollection = (paidAmount) => {
    const amount = parseFloat(paidAmount) || 0 // Ensure it's a valid number or default to 0
    const totalCollection = amount * 0.85 // Apply 15% platform fee
    return parseFloat(totalCollection) || 0.0
  }
  const calculatePlatformFee = (paidAmount) => {
    const amount = parseFloat(paidAmount) || 0
    return (amount * 0.15).toFixed(2) // 15% platform fee
  }
  const paidAmount = stripePayment?.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0)
  const paidManualAmount = manualPayment?.reduce(
    (sum, item) => sum + (parseFloat(item.amount) || 0),
    0,
  )
  const totalCollection = calculateTotalCollection(paidAmount)
  const platformFee = calculatePlatformFee(paidAmount)
  const gameTotalEarning = paidAmount + paidManualAmount

  return (
    <>
      <h6>Stripe Payments</h6>

      <CRow>
        <CCol sm={6} md={2}>
          <CWidgetStatsC
            color="primary"
            icon={<CIcon icon={cilPeople} height={36} />}
            value={totalUser}
            title="Total Users"
            inverse
            progress={{ value: 75 }}
            className="mb-4"
          />
        </CCol>
        <CCol sm={6} md={2}>
          <CWidgetStatsC
            color="primary"
            icon={<CIcon icon={cibCcStripe} height={36} />}
            value={stripePayment?.filter((item) => item.payment_type === 1).length}
            title="Paid Users"
            inverse
            progress={{ value: 75 }}
            className="mb-4"
          />
        </CCol>
        <CCol sm={6} md={2}>
          <CWidgetStatsC
            color="primary"
            icon={<CIcon icon={cibCcStripe} height={36} />}
            // value={stripePayment?.reduce(
            //   (sum, item) => sum + (parseFloat(item.amount) || 0),
            //   0,
            // )}
            value={
              entryPriceSymbol +
              stripePayment?.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0)
            }
            title="Total Collection"
            inverse
            progress={{ value: 75 }}
            className="mb-4"
          />
        </CCol>
        <CCol sm={6} md={2}>
          <CWidgetStatsC
            color="primary"
            icon={<CIcon icon={cilMinus} height={36} />}
            value={entryPriceSymbol + platformFee}
            title="MCT Fee"
            inverse
            progress={{ value: 75 }}
            className="mb-4"
          />
        </CCol>
        <CCol sm={6} md={2}>
          <CWidgetStatsC
            color="primary"
            icon={<CIcon icon={cibCcStripe} height={36} />}
            value={entryPriceSymbol + totalCollection}
            title="Total Earning"
            inverse
            progress={{ value: 75 }}
            className="mb-4"
          />
        </CCol>
      </CRow>

      <h6>Manual Payments</h6>
      <CRow>
        <CCol sm={6} md={3}>
          <CWidgetStatsC
            color="primary-gradient"
            icon={<CIcon icon={cilPeople} height={36} />}
            value={totalUser}
            title="Total Users"
            inverse
            progress={{ value: 75 }}
            className="mb-4"
          />
        </CCol>
        <CCol sm={6} md={3}>
          <CWidgetStatsC
            color="primary-gradient"
            icon={<CIcon icon={cilUserPlus} height={36} />}
            value={manualPayment?.length}
            title="Paid Users"
            inverse
            progress={{ value: 75 }}
            className="mb-4"
          />
        </CCol>
        <CCol sm={6} md={3}>
          <CWidgetStatsC
            color="primary-gradient"
            icon={<CIcon icon={cilWallet} height={36} />}
            value={entryPriceSymbol + paidManualAmount}
            title="Total Earning"
            inverse
            progress={{ value: 75 }}
            className="mb-4"
          />
        </CCol>
      </CRow>
      <h6>Total Collection</h6>
      <CRow>
        <CCol sm={6} md={3}>
          <CWidgetStatsC
            color="danger"
            icon={<CIcon icon={cibCcStripe} height={36} />}
            value={entryPriceSymbol + totalCollection}
            title="Stripe"
            inverse
            progress={{ value: 75 }}
            className="mb-4"
          />
        </CCol>
        <CCol sm={6} md={3}>
          <CWidgetStatsC
            color="danger"
            icon={<CIcon icon={cilUserPlus} height={36} />}
            value={entryPriceSymbol + paidManualAmount}
            title="Manual"
            inverse
            progress={{ value: 75 }}
            className="mb-4"
          />
        </CCol>
        <CCol sm={6} md={3}>
          <CWidgetStatsC
            color="danger"
            icon={<CIcon icon={cilWallet} height={36} />}
            value={`${entryPriceSymbol}${gameTotalEarning}`}
            title="Total Earning"
            inverse
            progress={{ value: 75 }}
            className="mb-4"
          />
        </CCol>
      </CRow>
    </>
  )
}

export default GamePayment
